import en from './en.md?raw';
import es from './es.md?raw';
import fr from './fr.md?raw';

export default { en, es, fr };
